import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./module");

export default function pageFetchLoader(context) {
    loadModuleOnElement(".tabs", loader, context);
    return context;
}
